import styled, { css } from 'styled-components';

const keyboardFocus = css`
  outline: 3px solid ${({ theme }) => theme.colors.softBlack};
  outline-offset: 2px;
`;

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1600;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.6);
  padding: 24px;
`;

export const Dialog = styled.div`
  width: min(720px, 100%);
  max-height: calc(100vh - 48px);
  overflow: auto;
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.softBlack};
  padding: 24px;
`;

export const Header = styled.header`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;

  h3 {
    margin: 0;
    font-size: 20px;
  }

  p {
    margin: 6px 0 0;
    color: ${({ theme }) => theme.colors.grey};
    font-size: 13px;
  }
`;

export const CloseButton = styled.button`
  border: 0;
  background: transparent;
  color: ${({ theme }) => theme.colors.softBlack};
  font-size: 22px;
  line-height: 1;
  cursor: pointer;

  &:focus-visible {
    ${keyboardFocus}
  }
`;

export const Field = styled.label`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 14px;
  font-size: 12px;
  font-weight: 600;

  input,
  select,
  textarea {
    border: 1px solid ${({ theme }) => theme.colors.lightGrey};
    border-radius: 4px;
    padding: 10px;
    font: inherit;
    color: ${({ theme }) => theme.colors.softBlack};
    background: ${({ theme }) => theme.colors.white};

    &:focus-visible {
      ${keyboardFocus}
    }
  }

  textarea {
    min-height: 140px;
    resize: vertical;
    font-weight: 400;
  }
`;

export const Chips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 0 0 14px;
`;

export const Chip = styled.button`
  border: 1px solid ${({ theme }) => theme.colors.lightGrey};
  border-radius: 999px;
  padding: 6px 10px;
  background: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.softBlack};
  font-size: 12px;
  cursor: pointer;

  &:focus-visible {
    ${keyboardFocus}
  }
`;

export const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 8px;
`;

export const Button = styled.button<{ variant?: 'primary' | 'ghost' | 'danger' }>`
  min-height: 38px;
  border: 0;
  border-radius: 4px;
  padding: 0 16px;
  font-weight: 600;
  cursor: pointer;
  background: ${({ theme, variant }) =>
    variant === 'ghost'
      ? theme.colors.white
      : variant === 'danger'
      ? theme.colors.red
      : theme.colors.main};
  color: ${({ theme, variant }) =>
    variant === 'ghost' ? theme.colors.softBlack : theme.colors.white};
  border: 1px solid
    ${({ theme, variant }) =>
      variant === 'ghost' ? theme.colors.lightGrey : 'transparent'};

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  &:focus-visible {
    ${keyboardFocus}
  }
`;

export const Summary = styled.div`
  margin: 16px 0;
  padding: 14px;
  border-radius: 5px;
  background: ${({ theme }) => theme.colors.lightGrey};
  font-size: 13px;
  font-weight: 400;

  strong {
    display: block;
    margin-bottom: 6px;
  }

  pre {
    margin: 10px 0 0;
    white-space: pre-wrap;
    font: inherit;
  }
`;

export const Status = styled.p<{ error?: boolean }>`
  margin: 0 0 12px;
  color: ${({ theme, error }) => (error ? theme.colors.red : theme.colors.grey)};
  font-size: 13px;
`;
